import UdeskLocales from 'UdeskLocales';
import React, { FC, memo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Button, Form, Input, message, Space, Spin } from 'udesk-ui';
import { FormWrapper, Logo, TipWrapper, Wrapper } from './components';
import Authorization from 'Component/pages/system-integration/components/Authorization';
import { getZendeskConfigsTicket } from 'src/api/zendeskConfigs/ticket';
import { postZendeskConfigsTicketAuth } from 'src/api/zendeskConfigs/ticket/auth';
import { putZendeskConfigsTicketCancelAuth } from 'src/api/zendeskConfigs/ticket/cancelAuth';
import { ZendeskConfigTicketAuthRequest } from 'src/api/types';

interface FormValues
    extends Pick<ZendeskConfigTicketAuthRequest, 'subdomain' | 'email' | 'apiToken'> {}

interface TempalteProps {}

const Tempalte: FC<TempalteProps> = memo((props) => {
    const locales = UdeskLocales['current'];

    const [form] = Form.useForm();

    const [initFormValues, setInitFormValues] = useState<FormValues>();

    const [authorized, setAuthorized] = useState(false);

    const {
        run: refresh,
        loading: getLoading,
        data,
    } = useRequest(() => getZendeskConfigsTicket({}), {
        onSuccess: (res) => {
            setAuthorized(res.data?.authStatus === 1);
            setInitFormValues({
                subdomain: res.data?.subdomain,
                email: res.data?.email,
                apiToken: res.data?.apiToken,
            });
            form.resetFields();
        },
    });

    const { run: onFinish, loading: postLoading } = useRequest(
        (values: FormValues) => postZendeskConfigsTicketAuth({ ...values, id: data?.data?.id }),
        {
            manual: true,
            onSuccess: () => {
                message.success(/* 授权成功 */UdeskLocales['current'].pages.systemIntegration.zendesk.components.ticket.index.authorizationSucceeded);
                refresh();
            },
        }
    );

    const { run: cancelAuth, loading: putLoading } = useRequest(
        () => putZendeskConfigsTicketCancelAuth({}),
        {
            manual: true,
            onSuccess: () => {
                message.success(/* 取消授权成功 */UdeskLocales['current'].pages.systemIntegration.zendesk.components.ticket.index.cancelAuthorizationSuccessfully);
                refresh();
            },
        }
    );

    return (
        <Wrapper>
            <TipWrapper>
                <Authorization authorized={authorized} />
            </TipWrapper>

            <Spin spinning={getLoading || postLoading || putLoading}>
                <FormWrapper>
                    <Logo className="logo">
                        <img src="/static/images/zendesk.webp" alt="" style={{ width: '100%' }} />
                    </Logo>

                    <Form
                        form={form}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 10 }}
                        initialValues={initFormValues}
                        onFinish={onFinish}
                        style={{ flex: 1 }}
                    >
                        <Form.Item name="subdomain" label="subdomain">
                            <Input disabled={authorized} />
                        </Form.Item>

                        <Form.Item name="email" label="email address">
                            <Input disabled={authorized} />
                        </Form.Item>

                        <Form.Item name="apiToken" label="API token">
                            <Input disabled={authorized} />
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 5, span: 10 }}>
                            {!authorized ? (
                                <Space>
                                    <Button key="applyAuth" type="primary" htmlType="submit">
                                        {locales.pages.admin.systemIntegration.applyAuth}
                                    </Button>
                                </Space>
                            ) : (
                                <Space>
                                    <Button key="cancelAuth" onClick={() => cancelAuth()}>
                                        {locales.pages.admin.systemIntegration.cancelAuth}
                                    </Button>
                                </Space>
                            )}
                        </Form.Item>
                    </Form>
                </FormWrapper>
            </Spin>
        </Wrapper>
    );
});

export default Tempalte;
